import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, LucideIcon } from 'lucide-react';

type PageShellProps = {
  badge?: string;
  badgeIcon?: LucideIcon;
  badgeColor?: string;
  title: string;
  subtitle?: string;
  backTo?: string;
  backLabel?: string;
  children?: React.ReactNode;
  headerExtra?: React.ReactNode;
  maxWidth?: string;
};

const PageShell: React.FC<PageShellProps> = ({
  badge,
  badgeIcon: BadgeIcon,
  badgeColor = 'var(--accent-primary)',
  title,
  subtitle,
  backTo = '/',
  backLabel = 'Ana sayfa',
  children,
  headerExtra,
  maxWidth = '1300px',
}) => (
  <section className="page-section" style={{ position: 'relative', zIndex: 2 }}>
    <div style={{ maxWidth, margin: '0 auto' }}>
      <Link to={backTo} className="page-back-link">
        <ArrowLeft size={18} />
        {backLabel}
      </Link>

      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          marginBottom: '32px',
          flexWrap: 'wrap',
          gap: '16px',
        }}
      >
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}>
          {badge && (
            <div
              className="section-badge"
              style={{
                color: badgeColor,
                background: `${badgeColor}14`,
                borderColor: `${badgeColor}33`,
                marginBottom: '12px',
              }}
            >
              {BadgeIcon && <BadgeIcon size={14} />}
              {badge}
            </div>
          )}
          <h1
            style={{
              margin: 0,
              fontSize: 'clamp(1.6rem, 4vw, 2.35rem)',
              fontWeight: 800,
              fontFamily: "'Space Grotesk', sans-serif",
            }}
          >
            <span className="gradient-text-white">{title}</span>
          </h1>
          {subtitle && (
            <p style={{ margin: '8px 0 0', color: '#64748b', fontSize: '15px', maxWidth: '560px', lineHeight: 1.55 }}>
              {subtitle}
            </p>
          )}
        </motion.div>
        {headerExtra}
      </div>

      {children}
    </div>
  </section>
);

export default PageShell;
